import type { PropsWithChildren } from 'react';
import { useContext } from 'react';
import { UserSessionContext } from '~/core/contexts/user-session';
import { useSentry } from '~/core/hooks/use-sentry';

const SentryBrowserWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { userSession } = useContext(UserSessionContext);
  useSentry(userSession);

  return <>{children}</>;
};

export default SentryBrowserWrapper;
